import { render } from "./UserLogin.vue?vue&type=template&id=4455df0e"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"

import "./UserLogin.vue?vue&type=style&index=0&id=4455df0e&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__